/*
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-16 15:08:20
 * @LastEditors: yangyi yangyi@caohua.com
 * @LastEditTime: 2026-05-29 17:27:49
 * @FilePath: /tiangong/src/views/report/comprehension-minigame-report/js/dimensionsData.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const checkedData = [
  {
    label: '计划',
    key: 'dimPlan',
    disabled: false
  },
  {
    label: '素材',
    key: 'dimImage',
    disabled: false
  },
  // {
  //   label: '平台',
  //   key: 'dimPlatform',
  //   disabled: false
  // },
  {
    label: '应用组',
    key: 'dimGameGroup',
    disabled: false
  },
  {
    label: '应用',
    key: 'dimGame',
    disabled: false
  },
  {
    label: '项目组',
    key: 'dimProjectGroup',
    disabled: false
  },
  {
    label: '人员',
    key: 'dimOp',
    disabled: false
  },
  {
    label: '媒体',
    key: 'dimMedia',
    disabled: false
  },
  {
    label: '投放版位',
    key: 'dimAdvPosition',
    disabled: false
  },
  {
    label: '账号',
    key: 'dimAdAccount',
    disabled: false
  },
  {
    label: '优化目标',
    key: 'dimOptimizationType',
    disabled: true
  },
  {
    label: '深度优化目标',
    key: 'dimDeepOptimizationType',
    disabled: true
  },
  {
    label: '流量来源',
    key: 'dimLaunchSource',
    disabled: false
  }
]

export const dimensionsData = [
  {
    title: '计划',
    key: 'planName',
    width: 100,
    overflow: true,
    align: 'left',
    showKey: 'dimPlan'
  },
  {
    title: '素材',
    key: 'imageName',
    overflow: true,
    width: 74,
    align: 'left',
    showKey: 'dimImage'
  },
  {
    title: '平台',
    key: 'platform',
    overflow: true,
    width: 84,
    align: 'left',
    showKey: 'dimPlatform'
  },
  {
    title: '应用组',
    key: 'gameGroupName',
    width: 80,
    overflow: true,
    align: 'left',
    showKey: 'dimGameGroup'
  },
  {
    title: '应用',
    key: 'gameName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimGame'
  },
  {
    title: '项目组',
    key: 'projectGroupName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimProjectGroup'
  },
  {
    title: '人员',
    key: 'opName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimOp'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimMedia'
  },
  {
    title: '投放版位',
    key: 'advPositionName',
    width: 74,
    overflow: true,
    align: 'left',
    showKey: 'dimAdvPosition'
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: 140,
    overflow: true,
    align: 'left',
    showKey: 'dimAdAccount'
  },
  {
    title: '优化目标',
    key: 'optimizationTypeName',
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimOptimizationType'
  },
  {
    title: '深度优化目标',
    key: 'deepOptimizationTypeName',
    width: 70,
    overflow: true,
    align: 'left',
    showKey: 'dimDeepOptimizationType'
  },
  {
    title: '流量来源',
    key: 'launchSourceName',
    width: 90,
    overflow: true,
    align: 'left',
    showKey: 'dimLaunchSource'
  }
]
export const checkedObj = {
  计划: 'dimPlan',
  素材: 'dimImage',
  平台: 'dimPlatform',
  应用组: 'dimGameGroup',
  应用: 'dimGame',
  项目组: 'dimProjectGroup',
  人员: 'dimOp',
  媒体: 'dimMedia',
  投放版位: 'dimAdvPosition',
  账号: 'dimAdAccount',
  优化目标: 'dimOptimizationType',
  深度优化目标: 'dimDeepOptimizationType',
  流量来源: 'dimLaunchSource'
}
